import {Component, OnInit, Inject} from '@angular/core';
import {Option, Response, StaticMethods} from '../../../model/GeneralModels';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {AppSettingsService} from '../../../services/app-settings.service';
import {IntroductionLetterService} from '../../../services/introduction-letter.service';
import {InsuranceMinimalInfo, Subset} from '../../../model/IntroductionLetterModel';
import {NewSubSetDialogComponent} from '../../../Dialogs/new-sub-set-dialog/new-sub-set-dialog.component';

@Component({
  selector: 'app-new-request',
  templateUrl: './new-request.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class NewRequestComponent implements OnInit {
  insurance: InsuranceMinimalInfo = new InsuranceMinimalInfo();
  productName: string;

  constructor(private router: Router, private dialog: MatDialog, public settings: AppSettingsService,
              private activatedRoute: ActivatedRoute,
              private introductionLetterService: IntroductionLetterService) {
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.productName = params.productName;
      if (StaticMethods.checkState(this.router, 'insurance', `/insurance-service/${this.productName}/basic-information`)) {
        console.log('insurance: ', history.state.insurance);
        this.insurance = new InsuranceMinimalInfo(history.state.insurance);
        console.log(this.insurance);
      }
    });
  }

  addNewSubset(subsetList: Subset[]) {
    const hasMe = subsetList.find(subset => {
      return subset.relation === 'ME';
    });
    const hasPartner = subsetList.find(subset => {
      return subset.relation === 'PARTNER';
    });
    const relationList = [];
    if (!hasMe) {
      relationList.push(new Option('خودم', 'ME'));
    }
    if (!hasPartner) {
      relationList.push(new Option('همسر', 'PARTNER'));
    }
    relationList.push(new Option('فرزند', 'CHILD'));
    const dialogRef = this.dialog.open(NewSubSetDialogComponent, {
      width: '350px',
      data: {relationList}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      console.log(result);
      if (result) {
        this.insurance.subsetList.push(result);
      }
    });
  }

  submit() {
    if (this.insurance.subsetList.length) {
      this.introductionLetterService.create({
        productName: this.insurance.productName,
        companyName: this.insurance.companyName,
        offerID: this.insurance.offerID,
        subsetList: this.insurance.subsetList.filter(subset => {
          return !subset.locked;
        }),
        insuranceNumber: this.insurance.insuranceNumber
      }).subscribe((response: Response) => {
        if (response.success) {
          this.router.navigate([`/insurance-service/${this.productName}/details`], {
            state: {
              requestID: response.data
            }
          });
        }
      });
    }
  }

  openDialog(subset: Subset) {
    StaticMethods.openDialog(this.dialog, 'آیا از حذف بیمه گذار مطمئن هستید؟', (result) => {
      if (result) {
        this.insurance.subsetList = this.insurance.subsetList.filter((value, index, arr) => {
          return value !== subset;
        });
      }
    }, '250px');
  }
}


